import {
  config,
  State as AuthState,
  setActions,
  saga as authSaga,
  updateConfig,
  getLocalState,
  createUrl,
  reducers,
} from "@triare/auth-redux";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { spawn, takeLatest, select, delay } from "redux-saga/effects";
import { EnhancedStore } from "@reduxjs/toolkit/src/configureStore";
import { useSelector } from "react-redux";
import { UrlObject } from "@triare/auth-redux/src/config";
import { AnyObject } from "@triare/auth-redux/src/saga/common";
import { User as AuthUser } from "@triare/auth-redux/src/saga/auth/useMe";
import socketProvider from "../../socket";
import { RootState } from "../index";
import dayjs, { Dayjs } from "dayjs";

export * from "@triare/auth-redux";

export default updateConfig({
  fetchDelay: Number.parseInt(process.env.REACT_APP_FETCH_DELAY || "0", 10),
  api: {
    url: process.env.REACT_APP_API || "",
  },
  displayName: "IOMV",
  // signIn: {
  //   ...config.signIn,
  //   refreshToken: {
  //     ...config.refreshToken,
  //     method: HttpMethod.POST,
  //   },
  //   requestBody: {
  //     byEmail: ({ remember, ...data }: SignInAction) => JSON.stringify(data),
  //     byUsername: ({ remember, ...data }: SignInAction) => JSON.stringify(data),
  //     byPhone: ({ remember, ...data }: SignInAction) => JSON.stringify(data),
  //     byService: ({ method, remember, ...data }: SignInAction) => JSON.stringify(data),
  //   },
  //   fetchMeAfterSuccess: true,
  // },
  createUrl: (
    url: string | UrlObject,
    addToUrl?: string,
    payload?: PayloadAction,
    data?: AnyObject,
    _query?: AnyObject,
  ) =>
    createUrl(url, addToUrl, payload, data, {
      ..._query,
      // lang: 'en',
    }),
});

export const moduleName = config.auth.name;

export type UserRoleType =
  | "student"
  | "admin"
  | "super_admin"
  | "leader"
  | "root"
  | "guest";

interface ITempUser {
  id: string;
}

export interface User extends ITempUser {
  fullName: string;
  birthdate?: dayjs.Dayjs | null;
  avatar?: string;
  plan?: string;
  gender?: string;
  address?: string;
  note?: string | null;
  country?: string;
  city?: string;
  zipCode?: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  role: UserRoleType;
  status: UserStatusType;
  isTwoFAActive: boolean;
  lastLoginAt?: string | null;
  settings: {
    isEmailVerified: boolean;
    isPhoneVerified: boolean;
  };
}

export interface State extends AuthState {
  user: User | null;
  secretKey: string;
}

export function useAuth(): State {
  return useSelector((state: RootState) => state[moduleName]);
}

export type UserStatusType = "active" | "deactivated" | "pending" | "blocked";

export const auth = createSlice({
  name: moduleName,
  initialState: getLocalState(),
  reducers: {
    ...reducers,

    // signInSuccess: (state, { payload }) => {
    //   Object.assign(state, payload);
    //
    //   state.signIn.loading = false;
    //   state.signIn.response = payload || null;
    //
    //   if (payload?.remember !== undefined) {
    //     state.remember = payload?.remember;
    //   }
    // },
  },
});

export const { actions } = auth;

setActions(actions);

function* selectAuthState() {
  return (yield select((state: RootState) => state[moduleName])) as State;
}

export function* saga(store: EnhancedStore) {
  yield spawn(authSaga, store);

  /** Handle socket connection */
  const { access } = store.getState()[config.auth.name];

  // For enabling chat-module uncomment socketProvider:

  // if (access && access.token) {
  //   socketProvider.init(`${access.token}`);
  // }

  yield takeLatest(
    [actions.signInSuccess.toString(), actions.refreshTokenSuccess.toString()],
    function* trigger() {
      yield delay(100);

      const authStore = (yield selectAuthState()) as State;

      // if (authStore && authStore.access && authStore.access.token) {
      //   socketProvider.reconnect(authStore.access.token);
      // }
    },
  );
  /* * * * * */

  yield takeLatest(actions.signOutSuccess.toString(), () => {
    window.localStorage.removeItem("chats_data");
  });

  // yield takeLatest(actions.confirmSuccess.toString(), (data) => {
  //   console.log(data);
  // });

  // yield takeLatest(actions.userMeSuccess.toString(), function* trigger() {
  //   const authData = (yield getState()) as State;
  //
  //   if (authData && authData.user && authData.user.role === UserRoles.GUEST) {
  //     yield put(signOut());
  //
  //     window.location.href = '/sign-up';
  //   }
  // });
}
